module.exports = __webpack_public_path__ + "static/img/taxcellent_bg.d22bdb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/matrix/taxcellent_bg.png
// module id = T13F
// module chunks = 34